import React from 'react'

import BrowserLocationHelper from '../utils/browser_location_helper';
import MapAddressPickerModal from './components/MapAddressPickerModal';
import {getAddressComponent} from './services/PlaceService'

export default class SelectAddressPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            address: props.initialAddress || {},
            showModal: false
        };

        this.handleChangeAddressInputClicked = this.handleChangeAddressInputClicked.bind(this);
        this.handleConfirmAddressButtonClicked = this.handleConfirmAddressButtonClicked.bind(this);
        this.handleOnModalHide = this.handleOnModalHide.bind(this);
        this.handleOnModalConfirm = this.handleOnModalConfirm.bind(this);
        this.gotoResultsPage = this.gotoResultsPage.bind(this);
    }

    getFullAddress() {
        const street_name   = this.state.address.street_name;
        const street_number = this.state.address.street_number;
        const city          = this.state.address.city;

        if (street_name && city) {
            return `${street_name} ${street_number || ''}, ${city}`;
        } else {
            return '';
        }
    }

    gotoResultsPage() {
        let url = this.props.searchURL;
        const address = this.state.address;
        
        url += "?latitude=" + address.latitude;
        url += "&longitude=" + address.longitude;
        url += "&street_name=" + address.street_name;
        url += "&street_number=" + address.street_number;
        url += "&city=" + address.city;
        url += "&postal_code=" + address.postal_code;

        BrowserLocationHelper.ChangeURL(url);
    }

    handleConfirmAddressButtonClicked(event) {
        if (event) { event.preventDefault(); }

        if (!this.state.address.latitude || !this.state.address.longitude) { return; }

        this.gotoResultsPage();
    }

    handleChangeAddressInputClicked(event) {
        event.preventDefault();

        if (window.google && window.google.maps) {
            this.setState({showModal: true});
        } else {
            try {
                const errorMessage = "SelectAddressPage tried to open the modal but google is not loaded";
                console.log(errorMessage);
                Raygun.send(new Error(errorMessage));
            } catch(err) {}
        }
    }

    handleOnModalHide() {
        this.setState({showModal: false});
    }

    handleOnModalConfirm(lat, lng, address_components = []) {
        //TODO: Change the way the state is managed by this component and MapAddressPickerContainer

        let street_name, street_number, city, postal_code;

        if (address_components && address_components.length === 0)
        {
            street_name = this.state.address.street_name;
            street_number = this.state.address.street_number;
            city = this.state.address.city;
            postal_code = this.state.address.postal_code;
        } else {
            street_name = getAddressComponent(["route"], address_components) || '';
            street_number = getAddressComponent(["street_number"], address_components) || '';
            city = getAddressComponent(["locality","administrative_area_level_3"], address_components) || '';
            postal_code = getAddressComponent(["postal_code"], address_components) || '';
        }

        this.setState({
            address: {
                latitude: lat,
                longitude: lng,
                street_name,
                street_number,
                city,
                postal_code
            }
        });

        setTimeout(this.gotoResultsPage, 500 );
    }

    render() {
        return (
            <div style={styles.mainContainer}>
                <div style={ styles.mainLabel}
                     dangerouslySetInnerHTML={ {__html: I18n.t('mobileapp.pages.landing.landing_title_html')}}/>
              <div style={ styles.inputContainer }>
                    <input
                        style={ styles.input }
                        type="text"
                        placeholder={I18n.t('pages.locations.search.insert_address')}
                        value={ this.getFullAddress()  }
                        readOnly
                        onClick={this.handleChangeAddressInputClicked}/>
                    <a style={ styles.a }
                       href="#"
                       onClick={this.handleConfirmAddressButtonClicked}
                       className="btn btn-primary">
                        <i className="fa fa-search"/>
                    </a>
                </div>
                <MapAddressPickerModal
                    show={this.state.showModal}
                    onModalHide={this.handleOnModalHide}
                    onConfirm={this.handleOnModalConfirm}
                    initialLat={this.state.address.latitude}
                    initialLng={this.state.address.longitude}
                    initialFullAddress={this.getFullAddress()}
                    autoGeolocalizeUser={!this.state.address.latitude || !this.state.address.longitude}
                />
            </div>
        )
    }
}

const styles = {
    mainLabel: {
        fontSize: '40px',
        lineHeight: '30px',
        fontWeight: '300',
        marginBottom: '50px'
    },
    mainContainer: {
        width: '100%',
        position: 'absolute',
        top: '20%'
    },
    inputContainer: {
        height: '44px'
    },
    input: {
        width: '80%',
        color: 'black',
        height: '100%',
        padding: '5px',
        border: 'none'
    },
    a: {
        height: '100%',
        fontSize: '21px',
        verticalAlign: 'top'
    }
};